<kno2-dialog-body>
    <div>
        <p>
            <strong>The subscription for this organization has been canceled.</strong>
            <br />
            You will still be able to use {{ brandDisplayName() }} until {{ finalDate() }}.
            <br />
            <br />
            If you feel this is in error, please contact your organization administrator to have them reactivate your subscription.
        </p>
    </div>
</kno2-dialog-body>

<kno2-dialog-footer>
    <button
        type="button"
        class="btn btn-primary"
        (click)="close()">
        Ok
    </button>
</kno2-dialog-footer>
